"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_router_dom_1 = require("react-router-dom");
var FormatText_1 = __importDefault(require("../FormatText"));
var RelativeRouteContext_1 = __importDefault(require("../../contexts/RelativeRouteContext"));
var RouterBackLink = function (props) {
    var parentUrl = react_1.useContext(RelativeRouteContext_1.default).parentUrl;
    var children = props.children;
    return (react_1.default.createElement(react_router_dom_1.Link, __assign({ to: parentUrl }, props), children || react_1.default.createElement(FormatText_1.default, { id: "ui.commons.back", uppercase: true })));
};
exports.default = RouterBackLink;
